import { render, staticRenderFns } from "./businessAccident.vue?vue&type=template&id=1bb0efd0&scoped=true&"
import script from "./businessAccident.vue?vue&type=script&lang=js&"
export * from "./businessAccident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0efd0",
  null
  
)

export default component.exports